import React, { useEffect } from 'react';
import _, { startCase } from 'lodash';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import PageHttp from '~/commons/components/PageHttp.jsx';

import FormGroup from '~/commons/components/FormGroup.jsx';
import { env } from '~/commons/config';

import { tradeDiscountStr } from '../utils';

const FieldSales = ({ values, tpCurrency }) => {
  const [showroomRes, showroomReq] = useHttpStatus();

  useEffect(() => {
    showroomReq({ url: '/api/core/users/self/showrooms' });
  }, []);

  return (
    <PageHttp res={showroomRes}>
      {(showrooms) => (
        <>
          <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">PRICES</h6>
          <div className="row">
            <div className="col">
              <FormGroup name="prices.retailPrice" label="Retail Price" type="number" min="0" />
            </div>
            <div className="col">
              <FormGroup name="prices.tradePrice" label="Trade Price" type="number" min="0"
                helpText={tradeDiscountStr(values.prices.retailPrice ?? 0, values.prices.tradePrice ?? 0, !_.includes(tpCurrency, values.prices.currency))}
              />
            </div>
            <div className="col">
              <FormGroup name="prices.currency" as="select">
                <option value=""> - </option>
                {env.currencies.map(({ code, symbol }) => (
                  <option value={code} key={code}>
                    {`${startCase(code)} - ${symbol}`}
                  </option>
                ))}
              </FormGroup>
            </div>
          </div>
          <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">SALES</h6>
          <div className="row">
            <div className="col">
              <FormGroup name="location" />
            </div>
            <div className="col">
              <FormGroup
                name="showroom"
                label="Showroom Code"
                as="select">
                <option value="">-</option>
                {showrooms.map((v) => (
                  <option value={v._id} key={v._id}>
                    {`${v.orgId} - ${v.showrmCode}`}
                  </option>
                ))}
              </FormGroup>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <FormGroup name="order.orderNo" label="Order No." />
            </div>
            <div className="col">
              <FormGroup name="order.itemNo" label="Order Item No." />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <FormGroup name="shippingSchedule" />
            </div>
          </div>
          <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">QR Code</h6>
          <div className="row">
            <div className="col">
              <FormGroup name="qr.redirect" />
            </div>
          </div>
        </>
      )}
    </PageHttp>
  )
};

export default FieldSales;
